<template>
  <Modal v-model="visible" title="提示" width="350px" class="my-modal top">
    <div class="text">
      <span>不存在的保单号：{{ list.join('，') }}</span>
    </div>

    <div class="ivu-modal-footer" slot="footer">
      <Button type="text" @click="visible = false">关闭</Button>
    </div>
  </Modal>
</template>

<script>
export default {
  data() {
    return {
      visible: false,
      list: []
    };
  },

  methods: {
    open(list) {
      this.visible = true;
      this.list = list;
      console.log(this.list)
    }
  }
};
</script>
<style lang="scss" scoped>
.my-modal /deep/ {
  .text {
    margin-top: 15px;
  }
}
</style>
